const eventTypes = [
  {
    slug: "weddings",
    name: "Weddings",
    headline: "A day built to be remembered, not managed.",
    description:
      "From the muhurtham to the reception, the hall adapts to the scale and rhythm of a Kerala wedding — open enough for a grand stage, flexible enough for an intimate ceremony.",
    configuration:
      "Stage + seating for up to 600, separate dining arrangement, bridal room on standby.",
    image: "/assets/wedding.png",
  },
  {
    slug: "receptions",
    name: "Receptions",
    headline: "Room to host everyone who matters.",
    description:
      "A single large floor plan means the reception line, seating and dinner service can run in parallel without the venue ever feeling divided.",
    configuration:
      "Floating capacity up to 700, buffet or plated service, flexible entry points.",
    image: "/assets/reception.png",
  },
  {
    slug: "engagements",
    name: "Engagements",
    headline: "A smaller occasion, given full attention.",
    description:
      "For engagements and family functions, the hall scales down comfortably without losing the sense of occasion.",
    configuration:
      "Partial hall layout, round-table seating, focused stage lighting.",
    image: "/assets/engage.png",
  },
  {
    slug: "corporate",
    name: "Corporate Gatherings",
    headline: "A change of address for the annual meeting.",
    description:
      "Team offsites, dealer meets and felicitations get a hall that reads as premium without the formality of a hotel conference room.",
    configuration:
      "Theatre or classroom seating, podium and AV point, adjoining space for refreshments.",
    image: "/assets/corp.png",
  },
  {
    slug: "conferences",
    name: "Conferences",
    headline: "Space for ideas to spread out.",
    description:
      "Panel discussions, seminars and product briefings benefit from the hall's uninterrupted floor and generous sightlines.",
    configuration:
      "Theatre-style seating up to 600, registration area at entry, breakout capacity in the second room.",
    image: "/assets/conf.png",
  },
  {
    slug: "exhibitions",
    name: "Exhibitions",
    headline: "A floor that welcomes footfall.",
    description:
      "Trade shows and community exhibitions use the open hall for stall rows with clear circulation and easy loading access.",
    configuration:
      "Open floor stall layout, wide entry for loading, flexible aisle spacing.",
    image: "/assets/exib.png",
  },
  {
    slug: "cultural",
    name: "Cultural Celebrations",
    headline: "Festivals, feasts and family gatherings.",
    description:
      "Onam sadyas, temple committee events and cultural programs are hosted comfortably with dining and stage running side by side.",
    configuration:
      "Sadya-style seating, stage for performances, dedicated dining zone.",
    image: "/assets/cul.png",
  },
  {
    slug: "community",
    name: "Community Events",
    headline: "For the gatherings that hold a neighbourhood together.",
    description:
      "Association meetings, felicitation events and public functions get a hall sized for genuine turnout, not a compromise.",
    configuration: "Flexible floating capacity, open seating, PA system point.",
    image: "/assets/com.png",
  },
];

export default eventTypes;
